import { ItemTypeConsts } from 'client/util/Constants';
import { values } from 'lodash';

export default {
  props: {
    parentType: {
      default: undefined,
      required: false,
      type: String,
      validator: function validator(value) {
        if (typeof value === 'undefined') {
          return true;
        }

        return !!(value && values(ItemTypeConsts).indexOf(value) !== -1);
      },
    },
  },
};
